import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((theme) => ({
  container: {},
  tabs: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: 'var(--ui-spacer-m)',
    listStyle: 'none',
    margin: 0,
    marginBottom: 'var(--ui-spacer-l)',
  },
  tab: {
    position: 'relative',
    padding: 'var(--ui-spacer-m)',
    marginBottom: 0,
    fontSize: '1.6rem',
    lineHeight: 1.25,
    // textTransform: 'uppercase',
    fontWeight: 600,
    color: 'var(--ui-color-disable)',
    cursor: 'pointer',
    '&.react-tabs__tab--selected': {
      color: 'var(--ui-color-text)',
      '&:after': {
        content: '""',
        position: 'absolute',
        height: '0.2rem',
        backgroundColor: theme.colors.secondary,
        left: 0,
        right: 0,
        bottom: 0,
      },
    },
  },
}))

export default useStyles
